import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Alert } from 'src/app/interfaces/alert';
import {
  Pet,
  PetMissingReportStatus,
  PetResidenceStatus,
  PetSpeciesFilterableType
} from 'src/app/interfaces/pet';
import { User, ProductType } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user/user.service';
import { Perk, WidgetSize } from 'src/app/interfaces/perk';
import { environment } from 'src/environments/environment';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { HelperService } from 'src/app/shared/helpers/helper.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UpdatePetDetailsInfoModalComponent } from '../update-pet-details-info-modal/update-pet-details-info-modal.component';
import { SCROLL_TO_OFFERS_QUERYPARAM } from 'src/app/constants/app.constants';
import { ADD_PET_QUERY_PARAM } from 'src/app/constants/route.constants';
import { PricingTableSubTypes } from 'src/app/shared/components/pricing-table/pricing-table.component';
import { FinishWelcomeGiftStepModalComponent } from '../finish-welcome-gift-step-modal/finish-welcome-gift-step-modal.component';
import {
  RegistrationProgressData,
  RegistrationProgressService,
} from 'src/app/services/registration-progress/registration-progress.service';
import { RegistrationFlowService } from 'src/app/services/registration-flow/registration-flow.service';
import { PaymentConfigService } from 'src/app/services/payment-config/payment-config.service';
import { RegistrationFlowStep } from 'src/app/constants/registration-flow.constants';
import { MemberShipOptionsService } from 'src/app/services/membership-options/membership-options.service';
import { FollowUsModalComponent } from 'src/app/modals/follow-us-modal/follow-us-modal.component';
import { UAParser } from 'ua-parser-js';
import { TokExploreModalComponent } from '../../modals/tok-explore-modal/tok-explore-modal.component';
import { TokCompleteModalComponent } from '../../modals/tok-complete-modal/tok-complete-modal.component';
import { CloudinaryService } from 'src/app/services/cloudinary/cloudinary.service';
import { ClickEventNumbersEnum } from 'src/app/interfaces/clickEventNumbers';
import { isPlatformBrowser } from '@angular/common';
import { OptInPopupService } from 'src/app/services/opt-in-popup/opt-in-popup.service';
import { Subscription } from 'rxjs';
import { NationalMicrochippingMonthPopupService } from 'src/app/services/national-microchipping-month-popup/national-microchipping-month-popup.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';
import { PlansPageConfig } from 'src/app/interfaces/pageConfig';
import { IdentialertSubSelectionModalComponent } from 'src/app/shared/components/subscription-pages/identialert-sub-selection-modal/identialert-sub-selection-modal.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  alert: Alert = null;
  optInAlert: Alert = null;
  activePets: Array<Pet> = [];
  incompletePetRegistations: Pet[] = [];
  loading = false;
  perks: Array<Perk> = [];
  petListString: string;
  welcomeMessage: string;
  previewPremium: boolean = null;
  productType = ProductType;
  public user: User;
  missingPetsWithNoReport: Pet[];
  tokPets: Pet[];
  petResidenceStatus = PetResidenceStatus;
  qrcode: string;
  ClickEventNumbersEnum = ClickEventNumbersEnum;
  public addPetQueryParams = { [ADD_PET_QUERY_PARAM]: true };

  public PricingTableSubTypes = PricingTableSubTypes;

  public pricingPlans = environment.stripePlans;
  // Backend-allowed subscription products (resolver pre-warms /payment). Null leaves the table on user-based logic.
  public availableProductIds: number[] | null = null;
  public alivePets: Array<Pet> = [];
  public isFullNameRegistrationCompleted = true;
  public isPetChipNumberRegistrationCompleted = true;
  public isMembershipSelectionCompleted = true;
  public isWelcomePackSelectCompleted = true;
  // Whether each step is part of this user's flow, read from the cached steps. Defaults to true.
  public isMembershipSelectionStepAvailable = true;
  public isWelcomeGiftStepAvailable = true;
  public WidgetSize = WidgetSize;
  public doesTheUserHaveCat = false;
  public doesTheUserHaveDog = false;
  public haveMembershipOptons = this.doesHaveAvailableMemberShipOptions();
  public isDeviceTypeMobile: boolean;
  private popupSeenSub: Subscription;
  public plan1Name: string;
  public plan2Name: string;
  public plan3Name: string;
  private plan1Route: string;
  private plan2Route: string;
  private plan3Route: string;
  public isUserBasic: boolean;
  public showDashboardWelcomeMessage: boolean;
  public showDashboardTopInfoMessage: boolean;
  public showUpgradeNowButton: boolean;
  public upgradeButtonLabel: string;
  public showSecondLineInThePerkInfoText: boolean;
  public useRebrandedLayout: boolean;

  // Upgrade Plan tile (rebranded dashboard only) - mirrors membership-options-v2's plan-card usage.
  public upgradePlanTitle: string;
  public upgradePlanSubtitle: string;
  public page: PlansPageConfig;
  public plan1YearlyPrice: string;
  public plan2YearlyPrice: string;
  public plan2MonthlyPrice: string;
  public plan3YearlyPrice: string;
  public plan3YearlyPriceOriginal: string;
  public isIdentiSmartTagPlanAvailable: boolean;
  public identibasePlusAvailable = true;
  public identiAlertAvailable = true;
  public smartTagSubAvailable = true;
  /**
   * Locator subscribers get the physical-tag card in place of the whole plan ladder,
   * mirroring v1's `user.productType === 6` branch in the pricing table.
   */
  public hasLocatorSubscription = false;
  public smartTagPrice: string;

  private showOptInPopup: boolean = true;
  private showNationalMicrochippingMonthPopup: boolean = false;

  private readonly showInstagramPopup: boolean = false;

  choosePetModalRef?: NgbModalRef;
  isBrowser: boolean;
  dashboardInfoBoxText: string;
  showDashboardInfoBox: boolean;

  constructor(
    private route: ActivatedRoute,
    public userService: UserService,
    private _router: Router,
    private checkoutService: CheckoutService,
    private _helperService: HelperService,
    private _modalService: NgbModal,
    private registrationProgressService: RegistrationProgressService,
    private registrationFlowService: RegistrationFlowService,
    private paymentConfigService: PaymentConfigService,
    private membershipOptionsService: MemberShipOptionsService,
    private cloudinaryService: CloudinaryService,
    private optInPopupService: OptInPopupService,
    private nationalMicroChippingMonthPopupService: NationalMicrochippingMonthPopupService,
    private configService: ConfigService,
    private featureFlagService: FeatureFlagsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.user = this.route.snapshot.data.user as User;
    this.perks = this.route.snapshot.data.perks as Array<Perk>;
    this.activePets = this.userService.filterAliveRegisteredPets(this.user.pets);
    this.petListString = this.createPetsListString(this.activePets);
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.plan1Name = this.configService.getTextFromKey('1-plan-name');
    this.plan2Name = this.configService.getTextFromKey('2-plan-name');
    this.plan3Name = this.configService.getTextFromKey('3-plan-name');
    this.plan1Route = this.configService.getTextFromKey('1-plan-route');
    this.plan2Route = this.configService.getTextFromKey('2-plan-route');
    this.plan3Route = this.configService.getTextFromKey('3-plan-route');
    this.dashboardInfoBoxText = this.configService.getTextFromKey('dashboard-info-box-text');
    this.showDashboardInfoBox = this.featureFlagService.isEnabled('isDashboardInfoBoxEnabled');
    this.showDashboardWelcomeMessage = this.featureFlagService.isEnabled('showDashboardWelcomeMessage');
    this.showDashboardTopInfoMessage = this.featureFlagService.isEnabled('showDashboardTopInfoMessage');
    this.showUpgradeNowButton = this.featureFlagService.isEnabled('showUpgradeNowButton');
    this.upgradeButtonLabel = this.showUpgradeNowButton ? 'Upgrade now' : 'Buy now';
    this.showSecondLineInThePerkInfoText = this.featureFlagService.isEnabled('showSecondLineInThePerkInfoText');
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');

    if (!this.featureFlagService.isEnabled('isNewsletterModalEnabled')) {
      this.showOptInPopup = false;
    }

    if (this.useRebrandedLayout) {
      this.upgradePlanTitle = this.configService.getTextFromKey('dashboard-upgrade-plan-title');
      this.upgradePlanSubtitle = this.configService.getTextFromKey('dashboard-upgrade-plan-subtitle');

      this.page = this.configService.getPage('plans');

      this.plan1YearlyPrice = this.configService.getTextFromKey('1-plan-yearly-price');
      this.plan2YearlyPrice = this.configService.getTextFromKey('2-plan-yearly-price');
      this.plan3YearlyPrice = this.configService.getTextFromKey('3-plan-yearly-price');
      this.plan3YearlyPriceOriginal = this.configService.getTextFromKey('3-plan-yearly-price-original');
      this.smartTagPrice = this.configService.getTextFromKey('3-plan-tag-price');

      this.plan1YearlyPrice =
        this.paymentConfigService.getYearlyDisplayPrice(ProductType.BasicPlus) ?? this.plan1YearlyPrice;
      this.plan2YearlyPrice =
        this.paymentConfigService.getYearlyDisplayPrice(ProductType.Premium) ?? this.plan2YearlyPrice;
      // Null when the backend offers Alert yearly-only, which hides the monthly option below.
      this.plan2MonthlyPrice = this.paymentConfigService.getMonthlyDisplayPrice(
        ProductType.Premium,
        this.configService.getTextFromKey('2-plan-monthly-price')
      );
      this.plan3YearlyPrice =
        this.paymentConfigService.getYearlyDisplayPrice(ProductType.Locator) ?? this.plan3YearlyPrice;

      this.isIdentiSmartTagPlanAvailable = this.featureFlagService.isEnabled('isIdentiSmartTagPlanAvailable');
    }
  }

  closeAlert() {
    this.alert = null;
  }
  closeOptInAlert() {
    this.optInAlert = null;
  }

  navigateToClaimPetOrEditPet() {
    if (this.user.pets.length > 0) {
      const incompletePets = this.user.pets.filter(
        (p) => p.name === null || p.name === '[to_be_completed_by_keeper]'
      );
      if (incompletePets.length > 0) {
        this._router.navigate(['/my-pet', incompletePets[0].id]);
      } else {
        // All of the previous pets details have been filled
        this._router.navigate(['/claim-pet'], {
          queryParams: { r: 'dashboard' },
        });
      }
    } else {
      // The user has not claimed any pets before
      this._router.navigate(['/claim-pet'], {
        queryParams: { r: 'dashboard' },
      });
    }
  }

  private createWelcomeMessage(): string {
    const doesHaveAvailableMemberShipOptions = this.doesHaveAvailableMemberShipOptions();
    const startText = doesHaveAvailableMemberShipOptions
      ? `Pet protection plans for ${this.petListString}`
      : 'Check out your perks for your pets';
      
    if (!doesHaveAvailableMemberShipOptions && !this.perks.length) {
      return '';
    }

    return startText;
  }

  private doesHaveAvailableMemberShipOptions(): boolean {
    const hasIdentibasePlusOption = this.membershipOptionsService.identiBasePlusAvailable(
      this.user
    );
    const hasIdentiAlertOption = this.membershipOptionsService.identiAlertAvailable(this.user);


    return hasIdentiAlertOption || hasIdentibasePlusOption;
  }

  public requestSmartTags(): void {
    this._router.navigate(['/get-identi-smart-tag']);
  }

  /**
   * When availableProductIds is provided, it overrides the user-based card availability set above.
   * It does nothing when the input is absent, so the existing feature-flag and user-based behaviour
   * stays in place.
   */
  private applyAvailableProductIds(): void {
    const availability = this.paymentConfigService.getProductAvailability(this.availableProductIds);
    if (!availability) return;
    this.identibasePlusAvailable = availability.basicPlus;
    this.identiAlertAvailable = availability.premium;
    this.smartTagSubAvailable = availability.smartTag;
  }

  private createPetsListString(pets): string {
    if (!pets.length) {
      return '';
    } else if (pets.length === 1) {
      return pets[0].name;
    } else if (pets.length === 2) {
      return `${pets[0].name} & ${pets[1].name}`;
    } else if (pets.length === 3) {
      return `${pets[0].name}, ${pets[1].name} & ${pets[2].name}`;
    } else {
      return `${pets[0].name}, ${pets[1].name} & your other pets`;
    }
  }

  private getMissingPetsWithNoReport(pets: Pet[]): Pet[] {
    return pets.filter((pet) => {
      return (
        (pet.residence === PetResidenceStatus.Lost ||
          pet.residence === PetResidenceStatus.Stolen) &&
        !pet.missingPetReports.find(
          (report) =>
            report.reportStatus === PetMissingReportStatus.AwaitingModeration ||
            report.reportStatus === PetMissingReportStatus.Open ||
            report.reportStatus === PetMissingReportStatus.AwaitingClosureFound ||
            report.reportStatus === PetMissingReportStatus.AwaitingClosureDeceased
        )
      );
    });
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  ngOnInit(): void {
    this.availableProductIds = this.paymentConfigService.getAvailableProductIds();

    if (this.useRebrandedLayout) {
      this.identibasePlusAvailable = this.membershipOptionsService.identiBasePlusAvailable(this.user);
      this.identiAlertAvailable = this.membershipOptionsService.identiAlertAvailable(this.user);
      this.smartTagSubAvailable = this.membershipOptionsService.smartTagSubAvailable(this.user);
      this.applyAvailableProductIds();

      this.hasLocatorSubscription =
        this.isIdentiSmartTagPlanAvailable &&
        this.userService.isUserLocator(this.user.originalProductType);
    }

    if (
      this.isBrowser &&
      this.registrationProgressService.getWelcomeGiftCompletedState()
    ) {
      localStorage.removeItem("arrived_from_email");
    }

    const parser = new UAParser();
    this.isDeviceTypeMobile = parser.getResult().device.type === 'mobile';

    if (
      this.route.snapshot.queryParams.checkout &&
      this.route.snapshot.queryParams.checkout === 'completed'
    ) {
      this.alert = {
        type: 'success',
        message: `Your payment has been received and processed. Your account will be upgraded shortly, please try refreshing your browser to see your new pet perks and update your account details.`,
      };
    }

    if (
      this.route.snapshot.queryParams.followUs &&
      this.route.snapshot.queryParams.followUs === 'open' &&
      this.showInstagramPopup
    ) {
      this.openInstagramPopup();
    }

    if (this.user) {
      this.doesTheUserHaveCat = !!this.user.pets.find(
        (pet) => pet.speciesFilter === PetSpeciesFilterableType.Cat
      );
      this.doesTheUserHaveDog = !!this.user.pets.find(
        (pet) => pet.speciesFilter === PetSpeciesFilterableType.Dog
      );
    }

    this.tokPets = this.userService.filterTokPets(this.user.pets);
    if (this.tokPets.length !== 0 && this.user.tokRequests.length !== 0) {
      this.openTokCompleteModal();
    }

    if (
      this.route.snapshot.queryParams.tokExplore &&
      this.route.snapshot.queryParams.tokExplore === 'open'
    ) {
      this.openTokExploreModal();
    }

    this.welcomeMessage = this.createWelcomeMessage();

    this.incompletePetRegistations = this.userService.filterIncompletePetRegistrations(
      this.user.pets
    );
    this.missingPetsWithNoReport = this.userService.isUserBasicOrBasicPlus(this.user.productType)
      ? []
      : this.getMissingPetsWithNoReport(this.activePets);

    const progressData = this.registrationProgressService.getRegistrationProgressData(this.user);
    this.handleRegistrationProgression(progressData);
    this.updateStepAvailability();
    this.registrationFlowService.loadSteps().subscribe(() => {
      this.updateStepAvailability();
      // Membership and welcome gift progress come from the steps, so read it again once they load
      this.handleRegistrationProgression(
        this.registrationProgressService.getRegistrationProgressData(this.user)
      );
      this.checkNewsletterPopup();
    });
    this.handlePremiumUsersWithWelcomeGiftStepAsLeftover();

    this.alivePets = this.userService.filterAlivePets(this.user.pets);

    if (this.showNationalMicrochippingMonthPopup) {
      if(this.doesTheUserHaveCat && this.doesTheUserHaveDog) {
        // Has both, determine which comes first in the pet list
        const petType = this.getFirstCatOrDog(this.user.pets);

        if (petType) {
          this.nationalMicroChippingMonthPopupService.checkAndShowNationalMicrochippingMonthPopup(petType);
        }
      } else if (this.doesTheUserHaveCat) {
        // Has only cat
        this.nationalMicroChippingMonthPopupService.checkAndShowNationalMicrochippingMonthPopup('cat');
      } else if (this.doesTheUserHaveDog) {
        // Has only dog
        this.nationalMicroChippingMonthPopupService.checkAndShowNationalMicrochippingMonthPopup('dog');
      }
    }
    this.isUserBasic = this.userService.isUserBasic(this.user.productType);
  }

  ngOnDestroy(): void {
    this.popupSeenSub?.unsubscribe();
  }

  select(planId?: string): void {
    if (planId) {
      this.loading = true;
      this.checkoutService
        .checkout([planId])
        .subscribe(
          () => {
            // Nothing should happen here because if checkout gets completed successfully, a redirect
            // will be triggered by stripe checkout
          },
          (err) => {
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.',
            };
          }
        )
        .add(() => {
          this.loading = false;
        });
    }
  }

  /**
   * Alert is the only plan with a billing-interval choice, so it opens the selection modal
   * instead of going straight to checkout. When the backend offers no monthly price the modal
   * would hold a single option, so skip it and buy the annual plan directly.
   */
  public selectAlert(): void {
    if (!this.plan2MonthlyPrice) {
      this.select(this.pricingPlans.identiAlertAnnual);
      return;
    }
    const modalRef = this._modalService.open(IdentialertSubSelectionModalComponent, {
      backdrop: 'static',
      centered: true,
      size: 'md',
    });
    modalRef.componentInstance.modalRef = modalRef;
    modalRef.componentInstance.isUpgrade = this.isUserBasic;
  }

  public planIdCheck(planId: string) {
    return [planId];
  }

  public navigateToProductPage(pricingTableSubType: string): void {
    switch (pricingTableSubType) {
      case PricingTableSubTypes.IDENTIBASEPLUS:
        this._router.navigate([this.plan1Route]);
        break;
      case PricingTableSubTypes.IDENTIALERT:
        this._router.navigate([this.plan2Route]);
        break;
      case PricingTableSubTypes.SMARTTAG:
        this._router.navigate([this.plan3Route]);
        break;
    }
  }

  public scrollToOffers() {
    this._helperService.scrollToElementById('offerListHeader');
  }

  public openUpdatePetDetailsInfoModal() {
    this._modalService.open(UpdatePetDetailsInfoModalComponent);
  }

  public areTheInitialRegistrationStepsIncomplete() {
    return (
      !this.isFullNameRegistrationCompleted ||
      !this.isPetChipNumberRegistrationCompleted ||
      !this.isMembershipSelectionCompleted ||
      !this.isWelcomePackSelectCompleted
    );
  }

  public onLastPerkRendered() {
    if (this.route.snapshot.queryParams.scrollTo) {
      if (this.route.snapshot.queryParams.scrollTo === SCROLL_TO_OFFERS_QUERYPARAM) {
        this.scrollToOffers();
      }
    }
  }

  private handleRegistrationProgression(progressData: RegistrationProgressData) {
    this.isFullNameRegistrationCompleted = progressData.isFullNameRegistrationCompleted;
    this.isMembershipSelectionCompleted = progressData.isMembershipSelectionCompleted;
    this.isPetChipNumberRegistrationCompleted = progressData.isPetChipNumberRegistrationCompleted;
    this.isWelcomePackSelectCompleted =
      this.featureFlagService.isEnabled('isPetPlanFreeInsuranceStep4Available') ? progressData.isWelcomePackSelectCompleted : true;
  }

  private updateStepAvailability(): void {
    this.isMembershipSelectionStepAvailable = this.registrationFlowService.isStepPresent(
      RegistrationFlowStep.MembershipOptions
    );
    this.isWelcomeGiftStepAvailable = this.registrationFlowService.isStepPresent(
      RegistrationFlowStep.WelcomeGift
    );
  }

  private checkNewsletterPopup(): void {
    if (this.showOptInPopup) {
      this.optInPopupService.checkAndShowNewsletterPopup(this.petListString, this.user);
      this.popupSeenSub = this.optInPopupService.popupSeenSuccess$.subscribe(() => {
        this.optInAlert = { type: 'success', message: 'Communication preferences saved.' };
      });
    }
  }

  private handlePremiumUsersWithWelcomeGiftStepAsLeftover() {
    if (
      this.featureFlagService.isEnabled('isPetPlanFreeInsuranceStep4Available') &&
      !this.isWelcomePackSelectCompleted &&
      this.doesUserHaveProductSub()
    ) {
      this._modalService.open(FinishWelcomeGiftStepModalComponent);
    }
  }

  private openInstagramPopup() {
    if (!this.areTheInitialRegistrationStepsIncomplete()) {
      this._modalService.open(FollowUsModalComponent);
    }
  }

  private openTokExploreModal() {
    this._modalService.open(TokExploreModalComponent, {
      size: 'lg',
    });
  }

  private openTokCompleteModal() {
    const modalRef = this._modalService.open(TokCompleteModalComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.petName = this.tokPets[0]?.name;
  }

  private doesUserHaveProductSub() {
    return (
      this.user.productType === this.productType.BasicPlus ||
      this.user.productType === this.productType.Premium
    );
  }

  public getPetImageUrl(petImageId: string): string {
    return this.cloudinaryService.getImageUrl(petImageId, 225, 225, '/assets/images/placeholders/paw-square-image.png');
  }

  public navigateToPetDetailPage(petId: Number) {
    return `/my-pet/${petId}`;
  }

  public getProgressData() {
    return this.registrationProgressService.getRegistrationProgressData(this.user);
  }

  /** Count of upgrade plan-cards actually shown */
  public get visiblePlanCount(): number {
    return [
      this.identibasePlusAvailable,
      this.identiAlertAvailable,
      this.isIdentiSmartTagPlanAvailable && this.smartTagSubAvailable,
    ].filter(Boolean).length;
  }

  private getFirstCatOrDog(userPets: Pet[]): 'cat' | 'dog' | null {
    for (const pet of userPets) {
      if (pet.speciesFilter === PetSpeciesFilterableType.Cat) {
        return 'cat';
      }
      if (pet.speciesFilter === PetSpeciesFilterableType.Dog) {
        return 'dog';
      }
    }
  return null;
  }
}
